import styled from "styled-components";
import Logo from "../Logo/Logo";
import Navigation from "../Navigation/Navigation";
import AccountSection from "../AccountSection/AccountSection";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

// background-image: linear-gradient(
//     to right,
//     #fbd314 0% 25%,
//     #057138 25% 50%,
//     #05a0dc 50% 75%,
//     #ee7d09 75% 100%
//   );
//   background-size: 100% 2px;
//   background-repeat: no-repeat;
//   background-position: 0 100%;

const StyledHeaderTop = styled.section`
  width: 100%;
  height: 50px;
  background-color: #fff1e2;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 20px;
  svg {
    margin-right: 10px;
    color: #ee7d09;
  }
  p {
    font-size: 14px;
    color: #000000;
    margin: 0px;
    padding: 0px;
    &:last-child {
      padding-right: 50px;
    }
  }
`;

const StyledHeader = styled.header`
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 10px 0px;
  background-color: #ffffff;
`;

const StyledHeaderInner = styled.section`
  width: calc(100% - 20px);
  margin: 0 auto;
  padding: 0px;
  display: flex;
  column-gap: 10px;
`;

const StyledLogoContaner = styled.section`
  width: 150px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Header = () => {
  return (
    <>
      <StyledHeaderTop>
        <p>
          <FontAwesomeIcon icon={faPhone} /> +91 9999999999
        </p>
        <p>
          <FontAwesomeIcon icon={faEnvelope} /> help@fourseasonsfresh.in
        </p>
      </StyledHeaderTop>
      <StyledHeader>
        <StyledHeaderInner>
          <StyledLogoContaner>
            <Logo />
          </StyledLogoContaner>
          <Navigation />
          <AccountSection />
        </StyledHeaderInner>
      </StyledHeader>
    </>
  );
};

export default Header;
